export const CONTACT = {
  phone: "+1 915-474-6256",
  phoneRaw: "+19154746256",
  email: "vertexhousemarketing@gmail.com",
  handle: "@vertexhousemarketing",
  whatsappMessage: "Hola Vertex House, quiero que analicen mi negocio sin costo.",
};

export const WHATSAPP_URL = `https://wa.me/${CONTACT.phoneRaw.replace(
  /[^0-9]/g,
  ""
)}?text=${encodeURIComponent(CONTACT.whatsappMessage)}`;

export const BRIEF_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSfIy1lXJUkWnhDmLY8Ux7T3FVzrinh6OX7h8e_E819LnPbGCw/viewform?usp=header";

export const SOCIALS = [
  {
    name: "Instagram",
    handle: "@vertexhousemarketing",
    url: "https://instagram.com/vertexhousemarketing",
  },
  {
    name: "Facebook",
    handle: "Vertex House",
    url: "https://www.facebook.com/profile.php?id=61590315922988",
  },
  {
    name: "TikTok",
    handle: "@vertex.house.mark",
    url: "https://www.tiktok.com/@vertex.house.mark",
  },
];
